import React from 'react';


const DefaultSectionUser = () => {
    return ( 
        <div className="grid w-[100%] h-[20vh] text-center text-white ml-auto mr-auto">
            <h1>Bienvenido a tu sección</h1>
            <p>Aquí podras visualizar tus preguntas, posteos y más...</p>
        </div>
     );
}
 
export default DefaultSectionUser;